/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelrealist3Inputs */



/**
* | output |
* | --- |
* | "The Grounded One" |
*
* @param {Personalityarchetypelabelrealist3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelrealist3 = /** @type {((inputs?: Personalityarchetypelabelrealist3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelrealist3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Grounded One")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Centrado")
	return /** @type {LocalizedString} */ ("Заземлённый")
});
export { personalityarchetypelabelrealist3 as "personalityArchetypeLabelRealist" }